export const monthEn = {
  0: 'monday',
  1: 'tuesday',
  2: 'wednesday',
  3: 'thursday',
  4: 'friday',
  5: 'saturday',
  6: 'sunday',
};

export const monthRu = {
  0: 'понедельник',
  1: 'вторник',
  2: 'среда',
  3: 'четверг',
  4: 'пятница',
  5: 'суббота',
  6: 'воскресенье',
};

export const monthBe = {
  0: 'Панядзелак',
  1: 'Аўторак',
  2: 'Серада',
  3: 'Чацвер',
  4: 'Пятніца',
  5: 'Субота',
  6: 'Нядзеля',
};

export const monthEnShort = {
  0: 'Mon',
  1: 'Tue',
  2: 'Wed',
  3: 'Thu',
  4: 'Fri',
  5: 'Sat',
  6: 'Sun',
};

export const monthRuShort = {
  0: 'Пнд',
  1: 'Втр',
  2: 'Срд',
  3: 'Чтв',
  4: 'Птн',
  5: 'Сбт',
  6: 'Вск',
};

export const monthBeShort = {
  0: 'Пнд',
  1: 'Аўт',
  2: 'Сер',
  3: 'Чцв',
  4: 'Пят',
  5: 'Суб',
  6: 'Няд',
};
